import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import LinearLoaderWithTime from "../../../components/Loaders/LinearLoaderWithTime";
import { AdleLogoLoader } from "../../../assets/svg/AdleLogoLoader";
import { useTranslationApp } from "../../../lib/i18next";
import { IS_ADLE_DOMAIN } from "../../../utils/constants";
import {
  AI_COMPETITORS_PROGRESS_FALLBACK,
  AI_COMPETITORS_SEARCHING_ERROR,
  AI_COMPETITORS_SEARCHING_RETRY,
} from "../../../i18n/keysTranslations";
import AiCompetitorsStepIntro from "./AiCompetitorsStepIntro";

const AI_COMPETITORS_LOADER_SX = {
  "& .MuiLinearProgress-root": {
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    "& .MuiLinearProgress-bar": {
      backgroundColor: "#000",
    },
  },
  "& .MuiTypography-root": {
    color: "#000 !important",
  },
};

const AiCompetitorsProgressStep = ({
  stepNumber,
  title,
  mutedTitle,
  description,
  progress = 8,
  label,
  error = false,
  onRetry,
}) => {
  const { t } = useTranslationApp();

  return (
    <Box>
      <AiCompetitorsStepIntro
        stepNumber={stepNumber}
        title={title}
        mutedTitle={mutedTitle}
        description={description}
      />
      <Box
        sx={{
          mt: { xs: 3, sm: 5 },
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          px: { xs: 0, sm: 2 },
        }}
      >
        {error ? (
          <>
            <Typography
              sx={{
                fontSize: { xs: 14, sm: 16 },
                color: "text.secondary",
                textAlign: "center",
              }}
            >
              {t(AI_COMPETITORS_SEARCHING_ERROR)}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={onRetry}
              sx={{
                mt: 2,
                height: 44,
                borderRadius: "12px !important",
                textTransform: "none",
                boxShadow: "none",
              }}
            >
              {t(AI_COMPETITORS_SEARCHING_RETRY)}
            </Button>
          </>
        ) : (
          <>
            {IS_ADLE_DOMAIN ? <AdleLogoLoader /> : null}
            <LinearLoaderWithTime
              progress={Math.max(1, Math.min(100, Number(progress) || 1))}
              label={label || t(AI_COMPETITORS_PROGRESS_FALLBACK)}
              labelSide={IS_ADLE_DOMAIN ? "bottom" : "top"}
              sx={{
                ...AI_COMPETITORS_LOADER_SX,
                width: "100%",
                maxWidth: "100%",
                "& .MuiTypography-root": {
                  ...AI_COMPETITORS_LOADER_SX["& .MuiTypography-root"],
                  fontSize: { xs: 14, sm: 16 },
                  px: { xs: 0.5, sm: 0 },
                },
              }}
            />
          </>
        )}
      </Box>
    </Box>
  );
};

export default AiCompetitorsProgressStep;
